import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import IconButton from '@mui/material/IconButton';
//import { ImageList, ImageListItem, ImageListItemBar } from '@mui/material/ImageList';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
//import StarBorderIcon from '@mui/icons-material/StarBorder';
import DownloadIcon from '@mui/icons-material/CloudDownload';
//import tileData from './tileData';
import {saveAs} from 'file-saver';
import { extendedstyles } from '../appstyles';
import { Box } from '@mui/material';

const s:any ={
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    background: 'background.paper',
  },
  imageList: {
    width: 500,
    height: 450,
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  titleBar: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
      'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  icon: {
    color: 'white',
  },
  videobox: {
    objectFit: "contain",
    width: 240,
    height: 200,
  },
  video:{
    position: 'absolute', 
    right: 0, 
    bottom: 0,
    minWidth: '100%', 
    minHeight: '100%',
    width: 'auto', 
    height: 'auto', 
    zIndex: "-100",
    backgroundSize: 'cover',
    overflow: 'hidden'
  }
};

/**
 * The example data is structured as follows:
 *
 * import image from 'path/to/image.jpg';
 * [etc...]
 *
 * const tileData = [
 *   {
 *     type: image,
 *     img: image,
 *     vid: video,
 *     title: 'Image',
 *     author: 'author',
 *     featured: true,
 *   },
 *   {
 *     [etc...]
 *   },
 * ];
 */


class ResourceView extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      count:0
    };
  }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.page !== nextProps.page) {
  //       this.setState({page: nextProps.page});
  //   }
  // }

  handleClick = (name:any) => (event:any) => {
    //var btn = event.target;
    //var {result,tileData} = this.props;
    const value = event.target.value;
    var {result} = this.props;
    console.log('result',result,value,name);
    var blob = new Blob(value);
    saveAs(blob);
    // var d = new Download();
    // var s = this.state.dataset;
    // if(name=='pdf'){
    //   d.downloadPDF(data,record,user);
    //   return;
    // }
    // var fns = {txt:d.txtDemo,json:d.jsonData, pdf:d.pdfData};
    // if(s == null) {
    //   d.normalize(data,record,user,(ss)=>{
    //     this.setState({dataset:ss});
    //     fns[name]('selified_verification',ss,data,record,user);
    //   });
    // }
    // else{
    //   fns[name]('selified_verification',s,data,record,user);
    // }
  } 

  render() {
    //const { name, tileData, classes, theme } = this.props;
    const { tileData, classes} = this.props;

    return (
      <Box sx={{...s.root}}>
        <ImageList rowHeight={200} gap={1} sx={{...s.imageList}}>
          {tileData.map((tile:any) => (
            <ImageListItem key={tile.resid} cols={tile.featured ? 2 : 1} rows={tile.featured ? 2 : 1}>
              {/* {tile.type=='image'?<img src={tile.img} alt={tile.title} />
                                 :<video src={tile.vid} alt={tile.title} muted playsInline controls></video>} */}
              {tile.type==='image'?<Box component='img' id={tile.resid} src={tile.src} alt=""/>
                                 :<Box sx={{...s.videobox}}>
                                    <Box component='video' id={tile.resid} src={tile.src} sx={{...s.videobox}} muted playsInline controls></Box>
                                  </Box>}
              <ImageListItemBar
                title={tile.title}
                position="top"
                actionIcon={
                  // <IconButton sx={{...s.icon}} onClick={this.handleClick(tile.resid,tile)}>
                  <IconButton sx={{...s.icon}} onClick={this.handleClick(tile.resid)}>
                    <DownloadIcon />
                  </IconButton>
                }
                actionPosition="right"
                sx={{...s.titleBar}}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
    );
  }
}

ResourceView.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default ResourceView;